import React from 'react';
import {Avatar,Button,Box,Nav,Stack,Text,Sidebar,Grid} from 'grommet';
import {Launch,User,Package,Apps,Test,Organization,Plan, Logout,Group, UserSettings,Close, History, Catalog} from 'grommet-icons';
import {Link} from "react-router-dom";
import {SignOut} from './utils/shared/requests'
import { withRouter } from 'react-router-dom';

const SidebarHeader = (props) => {
  const username = sessionStorage.getItem('username')
  return(
    <Grid>
    <Button icon={<Close />} onClick={() => {props.toggleSidebar()}} size='small' />
    <Box align="center" gap="small" direction="row" margin={{bottom: 'xsmall'}}>
      <Stack alignSelf="start" align="center" anchor="top-right">
        <Avatar focusIndicator={false} hoverIndicator>
          <User />
        </Avatar>
        <Box pad="xsmall" background="green" round responsive={false} />
      </Stack>
      <Text size='small'>{username}</Text>

    </Box>
   
  </Grid>
  )
}
  
const SidebarButton = ({ icon, label, ...rest }) => (
  <Box pad="small" round onClick={() =>{}} hoverIndicator>
    <Button
      round
      gap="medium"
      alignSelf="start"
      plain
      icon={icon}
      label={label}
      {...rest}
    />
  </Box>
);

const SidebarFooter = (props, handleIsUserAuthenticated) => {
  return (
    <Nav>
      <SidebarButton onClick={(e) => {SignOut(props)}} icon={<Logout />} label="Log out" />
    </Nav>
  )
}
  

const MainNavigation = (props) => {
  let quote;
  if (props.displayQuote){
    quote = (
      <Link to='/quote/new' style={{textDecoration:"none", color: 'inherit'}}>
        <SidebarButton icon={<Plan />} label="Quote" />
      </Link>
    )
  } else {
    quote = null
  }
  if (props.userRole === 'Lab'){
  return (
      <Nav gap="small" responsive={true}>
       <Link to='/dashboard' style={{textDecoration:"none", color: 'inherit'}}>
        <SidebarButton icon={<Apps />} label={<Text size='small'>Dashboard</Text>} />
      </Link>
      <Link to='/shipment/new' style={{textDecoration:"none", color: 'inherit'}}>
        <SidebarButton icon={<Launch />} label={<Text size='small'>Ship</Text>} />
      </Link>
      <Link to='/addresses/all' style={{textDecoration:"none", color: 'inherit'}}>
        <SidebarButton icon={<Catalog />} label={<Text size='small'>Address Book</Text>} />
      </Link>
      {quote}
      <Link to='/shipments/all' style={{textDecoration:"none", color: 'inherit'}}>
        <SidebarButton icon={<History />} label={<Text size='small'>History</Text>} />
      </Link>
      <Link to='/users/all' style={{textDecoration:"none", color: 'inherit'}}>
        <SidebarButton icon={<UserSettings />} label={<Text size='small'>Users</Text>} />
      </Link>
      <Link to='/customers/all' style={{textDecoration:"none", color: 'inherit'}}>
        <SidebarButton icon={<Group />} label={<Text size='small'>Customers</Text>} />
      </Link>
    </Nav>
  );
  } else if (props.userRole === "SuperAdmin"){
    return (
      <Nav gap="small" responsive={true}>
      <Link to='/admin/dashboard' style={{textDecoration:"none", color: 'inherit'}}>
        <SidebarButton icon={<Apps />} label={<Text size='small'>Dashboard</Text>} />
      </Link>
      <Link to='/admin/shipments/all' style={{textDecoration:"none", color: 'inherit'}}>
        <SidebarButton icon={<History />} label={<Text size='small'>History</Text>} />
      </Link>
      <Link to='/shipment/new' style={{textDecoration:"none", color: 'inherit'}}>
        <SidebarButton icon={<Launch />} label={<Text size='small'>Ship</Text>} />
      </Link>
      <Link to='/quote/new' style={{textDecoration:"none", color: 'inherit'}}>
        <SidebarButton icon={<Plan />} label={<Text size='small'>Quote</Text>} />
      </Link>
      <Link to='/admin/addresses/all' style={{textDecoration:"none", color: 'inherit'}}>
        <SidebarButton icon={<Catalog />} label={<Text size='small'>Address Book</Text>} />
      </Link>
      <Link to='/admin/commodities/all' style={{textDecoration:"none", color: 'inherit'}}>
        <SidebarButton icon={<Package />} label={<Text size='small'>Commodities</Text>}/>
      </Link>
      <Link to='/admin/users/all' style={{textDecoration:"none", color: 'inherit'}}>
        <SidebarButton icon={<UserSettings />} label={<Text size='small'>Users</Text>} />
      </Link>
      <Link to='/admin/organisations/all' style={{textDecoration:"none", color: 'inherit'}}>
        <SidebarButton icon={<Organization />} label={<Text size='small'>Organisations</Text>} />
      </Link>
      <Link to='/admin/labs/all' style={{textDecoration:"none", color: 'inherit'}}>
        <SidebarButton icon={<Test />} label={<Text size='small'>Labs</Text>} />
      </Link>
      <Link to='/admin/customers/all' style={{textDecoration:"none", color: 'inherit'}}>
        <SidebarButton icon={<Group />} label={<Text size='small'>Customers</Text>} />
      </Link>
    </Nav>
    )
  }  if (props.userRole === 'Customer'){
    console.log(props)
    return (
        <Nav gap="small" responsive={true}>
        <Link to='/shipment/new' style={{textDecoration:"none", color: 'inherit'}}>
          <SidebarButton icon={<Launch />} label={<Text size='small'>Ship</Text>} />
        </Link>
        {quote}
        
        <Link to='/shipments/all' style={{textDecoration:"none", color: 'inherit'}}>
          <SidebarButton icon={<History />} label={<Text size='small'>History</Text>} />
        </Link>
      </Nav>
    );
    } else {
    return null
  }
}
  

function SideBar(props) {
  const user = props.location.state;
  return (
        <Sidebar
          style={{bottom: 0,overflow:'scroll',position: "sticky", zIndex: 1}}
          responsive={true}
          background="#18445C"
          header={<SidebarHeader user={user} userRole={props.userRole} toggleSidebar={props.toggleSidebar}/>}
          footer={<SidebarFooter props={props} handleIsUserAuthenticated={props.handleIsUserAuthenticated} userRole={props.userRole}/>}
        >
          <MainNavigation userRole={props.userRole} displayQuote={props.displayQuote}/>
        </Sidebar>
  );
}

export default withRouter(SideBar)
